module.exports = __webpack_public_path__ + "img/loading-picture.1bafbb74.gif";